var Backbone, SharedFooterIntlMainView, SharedFooterIntlPhoneNumberView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedFooterIntlPhoneNumberView = require('./phone_number_view');

SharedFooterIntlMainView = (function(superClass) {
  extend(SharedFooterIntlMainView, superClass);

  function SharedFooterIntlMainView() {
    return SharedFooterIntlMainView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterIntlMainView.prototype["class"] = 'box support-footer';

  SharedFooterIntlMainView.prototype.id = 'intl_footer';

  SharedFooterIntlMainView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.shared';
    this.template = this.options.template;
    return this.emailFormModel = this.options.model;
  };

  SharedFooterIntlMainView.prototype.renderPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterIntlPhoneNumberView({
          emailFormModel: _this.emailFormModel,
          renderPopup: true
        });
        return phoneNumberView.render();
      };
    })(this));
  };

  SharedFooterIntlMainView.prototype.renderEmailForm = function() {
    return this.options.emailUs();
  };

  SharedFooterIntlMainView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SharedFooterIntlMainView.prototype.toHash = function() {
    return window.getOrderInfoForBH(Groupon.Support.currentOrder);
  };

  SharedFooterIntlMainView.prototype.events = {
    "click span.lnk-call-us": "renderPhoneNumberView",
    "click span.lnk-email-us": "renderEmailForm"
  };

  return SharedFooterIntlMainView;

})(Backbone.View);

module.exports = SharedFooterIntlMainView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9mb290ZXIvSU5UTC9tYWluX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9mb290ZXIvSU5UTC9tYWluX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUEsbUVBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2IsK0JBQUEsR0FBa0MsT0FBQSxDQUFRLHFCQUFSOztBQUU1Qjs7Ozs7OztzQ0FDSixPQUFBLEdBQU87O3FDQUNQLEVBQUEsR0FBSTs7cUNBRUosVUFBQSxHQUFZLFNBQUMsT0FBRDtJQUNWLElBQUMsQ0FBQSxPQUFELEdBQVcsT0FBQSxJQUFXO0lBQ3RCLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBVixDQUFnQixDQUFoQixFQUFtQixDQUFDLElBQUQsQ0FBTSxDQUFDLE1BQVAsQ0FBYyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVosQ0FBZCxDQUFuQjtJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZLElBQUMsQ0FBQSxPQUFPLENBQUM7V0FDckIsSUFBQyxDQUFBLGNBQUQsR0FBa0IsSUFBQyxDQUFBLE9BQU8sQ0FBQztFQUxqQjs7cUNBT1oscUJBQUEsR0FBdUIsU0FBQTtXQUNyQixxQ0FBQSxDQUF1QyxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUE7QUFDckMsWUFBQTtRQUFBLGVBQUEsR0FBa0IsSUFBSSwrQkFBSixDQUFvQztVQUNwRCxjQUFBLEVBQWdCLEtBQUMsQ0FBQSxjQURtQztVQUVwRCxXQUFBLEVBQWEsSUFGdUM7U0FBcEM7ZUFJbEIsZUFBZSxDQUFDLE1BQWhCLENBQUE7TUFMcUM7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQXZDO0VBRHFCOztxQ0FTdkIsZUFBQSxHQUFpQixTQUFBO1dBQ2YsSUFBQyxDQUFBLE9BQU8sQ0FBQyxPQUFULENBQUE7RUFEZTs7cUNBR2pCLE1BQUEsR0FBUSxTQUFBO1dBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBbEIsRUFBOEIsSUFBQyxDQUFBLFNBQS9CLENBQVo7RUFETTs7cUNBR1IsTUFBQSxHQUFRLFNBQUE7V0FDTixNQUFNLENBQUMsaUJBQVAsQ0FBeUIsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUF6QztFQURNOztxQ0FHUixNQUFBLEdBQ0U7SUFBQSx3QkFBQSxFQUE0Qix1QkFBNUI7SUFDQSx5QkFBQSxFQUE2QixpQkFEN0I7Ozs7O0dBOUJtQyxRQUFRLENBQUM7O0FBaUNoRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
